import React from "react";
import { Helmet } from "react-helmet-async";
export const SeoHead = ({ title, description, canonicalPath }) => {
    const canonicalUrl = canonicalPath ? `${window.location.origin}${canonicalPath}` : undefined;
    return (React.createElement(Helmet, null,
        React.createElement("title", null, title),
        React.createElement("meta", { name: "description", content: description }),
        React.createElement("meta", { name: "robots", content: "noindex" }),
        canonicalUrl && React.createElement("link", { rel: "canonical", href: canonicalUrl })));
};
export default SeoHead;
